import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--disclosure"
export default class extends Controller {
  static targets = ["content", "button"]

  connect() {
    this.boundKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
  }

  toggle() {
    if (this.contentTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.contentTarget.classList.remove("hidden")
    this.buttonTargets.forEach(btn => btn.setAttribute("aria-expanded", "true"))
  }

  close() {
    this.contentTarget.classList.add("hidden")
    this.buttonTargets.forEach(btn => btn.setAttribute("aria-expanded", "false"))
  }

  handleKeydown(event) {
    if (event.key === "Escape" && !this.contentTarget.classList.contains("hidden")) {
      this.close()
    }
  }
}
